import type { NodeSn } from '@ipfabric/utils';
import { EDGE_HIGHLIGHT_COLOR } from 'components/Graph/constants';
import type { GraphCommandFactory } from 'components/Graph/model/GraphCommandContext';
import { getNodeHighlightedEdges } from './helpers/getNodeHighlightedEdges';
import { highlightEdges } from './highlightEdges';

export interface SetPathInspectorActiveNodeCommand {
  nodeSn: NodeSn | null;
}

export const setPathInspectorActiveNode: GraphCommandFactory<
  SetPathInspectorActiveNodeCommand
> = (cmdContext, dispatch) => (command) => {
  cmdContext.updateState((draft) => {
    if (
      Object.keys(draft.pathlookup.pathInspector.selectedPackets).length > 0
    ) {
      draft.pathlookup.pathInspector.activeNodeSn = command.nodeSn;
      const nodeHighlightedEdges = getNodeHighlightedEdges(
        draft.pathlookup.pathInspector.activeNodeSn,
        draft.pathlookup.pathInspector.highlightedEdges,
      );
      if (nodeHighlightedEdges !== undefined) {
        dispatch(highlightEdges, {
          color: EDGE_HIGHLIGHT_COLOR,
          edges: [
            ...nodeHighlightedEdges.incomingEdges,
            ...nodeHighlightedEdges.outgoingEdges,
          ],
        });
      }
    }
  });
};
